import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { spacesKeys } from 'src/features/spaces/api/query-keys/spaces';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { assignSpacesToSpaceGroup } from '../lib/space-groups';
import { spaceGroupsKeys } from '../query-keys/space-groups';

export const useAssignSpacesToSpaceGroup = (onSuccess?: () => void) => {
  const { t } = useTranslation(['spaceGroups', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      spaceGroupToken,
      spacesTokens,
    }: {
      spaceGroupToken: string;
      spacesTokens: string[];
    }) => assignSpacesToSpaceGroup(spaceGroupToken, spacesTokens),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: spaceGroupsKeys.lists(),
        });

        queryClient.invalidateQueries({
          queryKey: spacesKeys.lists(),
        });
      });
      toast.success(t('spaceGroups:common.createGroupDialog.successAssign'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
